import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

const TermsConditions = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg-primary)',
      padding: '40px 24px'
    }}>
      <div style={{
        maxWidth: '900px',
        margin: '0 auto'
      }}>
        {/* Back Link */}
        <Link to="/" style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          color: 'var(--accent-gold)',
          textDecoration: 'none',
          marginBottom: '32px',
          fontSize: '14px'
        }}>
          <ArrowLeft size={16} />
          Back to Home
        </Link>

        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          marginBottom: '40px'
        }}>
          <div style={{
            width: '56px',
            height: '56px',
            borderRadius: '12px',
            background: 'rgba(212, 175, 55, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <FileText size={28} color="var(--accent-gold)" />
          </div>
          <div>
            <h1 style={{
              fontSize: '32px',
              fontWeight: 700,
              color: 'var(--text-primary)',
              marginBottom: '4px'
            }}>Terms & Conditions</h1>
            <p style={{ color: 'var(--text-muted)', fontSize: '14px' }}>
              Last updated: January 2026
            </p>
          </div>
        </div>

        {/* Content */}
        <div style={{
          background: 'var(--bg-secondary)',
          borderRadius: '16px',
          border: '1px solid var(--border-subtle)',
          padding: '40px'
        }}>
          <div style={{ color: 'var(--text-secondary)', lineHeight: 1.8, fontSize: '15px' }}>
            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                1. Agreement to Terms
              </h2>
              <p>
                By accessing or using PROP INDEXA's services, you agree to be bound by these Terms and Conditions. If you disagree with any part of these terms, you may not access or use our services. These terms apply to all visitors, users, and others who access or use our platform.
              </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                2. Eligibility
              </h2>
              <p style={{ marginBottom: '12px' }}>To use our services, you must:</p>
              <ul style={{ marginLeft: '24px' }}>
                <li style={{ marginBottom: '8px' }}>Be at least 18 years of age</li>
                <li style={{ marginBottom: '8px' }}>Have the legal capacity to enter into binding contracts</li>
                <li style={{ marginBottom: '8px' }}>Not be prohibited from using our services under applicable laws</li>
                <li style={{ marginBottom: '8px' }}>Provide accurate and complete registration information</li>
              </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                3. Trading Accounts
              </h2>
              <p style={{ marginBottom: '12px' }}>
                PROP INDEXA provides funded trading accounts under specific terms:
              </p>
              <ul style={{ marginLeft: '24px' }}>
                <li style={{ marginBottom: '8px' }}>All accounts are for simulated trading purposes</li>
                <li style={{ marginBottom: '8px' }}>Traders must adhere to all trading rules and risk parameters</li>
                <li style={{ marginBottom: '8px' }}>Violation of rules may result in immediate account termination</li>
                <li style={{ marginBottom: '8px' }}>Account credentials must not be shared with third parties</li>
                <li style={{ marginBottom: '8px' }}>One account per person unless otherwise authorized</li>
              </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                4. Trading Rules
              </h2>
              <p style={{ marginBottom: '12px' }}>All traders must comply with the following rules:</p>
              <ul style={{ marginLeft: '24px' }}>
                <li style={{ marginBottom: '8px' }}><strong>Daily Drawdown:</strong> Maximum daily loss limit based on account type</li>
                <li style={{ marginBottom: '8px' }}><strong>Maximum Drawdown:</strong> Overall drawdown limit from starting balance</li>
                <li style={{ marginBottom: '8px' }}><strong>Profit Target (1-Step accounts):</strong> 10% profit target during evaluation</li>
                <li style={{ marginBottom: '8px' }}><strong>Prohibited Activities:</strong> News trading during high-impact events, arbitrage, copy trading between accounts</li>
              </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                5. Payments and Payouts
              </h2>
              <ul style={{ marginLeft: '24px' }}>
                <li style={{ marginBottom: '8px' }}>All payments are processed in cryptocurrency</li>
                <li style={{ marginBottom: '8px' }}>Account fees are non-refundable once the account has been activated</li>
                <li style={{ marginBottom: '8px' }}>Profit payouts are processed within 24-72 hours after approval</li>
                <li style={{ marginBottom: '8px' }}>Minimum payout threshold applies as specified in your account terms</li>
                <li style={{ marginBottom: '8px' }}>Traders receive the profit split percentage as advertised (up to 80%)</li>
              </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                6. Account Termination
              </h2>
              <p style={{ marginBottom: '12px' }}>
                PROP INDEXA reserves the right to terminate accounts for:
              </p>
              <ul style={{ marginLeft: '24px' }}>
                <li style={{ marginBottom: '8px' }}>Violation of trading rules</li>
                <li style={{ marginBottom: '8px' }}>Fraudulent activity or misrepresentation</li>
                <li style={{ marginBottom: '8px' }}>Breach of these terms and conditions</li>
                <li style={{ marginBottom: '8px' }}>Any activity deemed harmful to the platform</li>
              </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                7. Limitation of Liability
              </h2>
              <p>
                PROP INDEXA shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use our services. Our total liability shall not exceed the amount you paid for the service in question.
              </p>
            </section>

            <section>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                8. Changes to Terms
              </h2>
              <p>
                We reserve the right to modify these terms at any time. We will notify users of any material changes via email or through our platform. Your continued use of the service after such modifications constitutes your acceptance of the updated terms.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
